import { useEffect, useState, useCallback } from "react";
import { useAuthStore } from "@/stores/auth-store";

export function useRefreshWarning() {
  const [showWarning, setShowWarning] = useState(false);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  const dismissWarning = useCallback(() => {
    setShowWarning(false);
  }, []);

  const confirmRefresh = useCallback(() => {
    window.location.reload();
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      const isF5 = e.key === "F5";
      const isCmdR =
        (e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "r";

      if (isF5 || isCmdR) {
        e.preventDefault();
        setShowWarning(true);
      }
    };

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isAuthenticated]);

  return {
    showWarning,
    dismissWarning,
    confirmRefresh,
  };
}
